import { Link } from "react-router-dom";
import type { Episode } from "@/types/episode";

interface EpisodeRowProps {
  episode: Episode;
  latest?: boolean;
}

export default function EpisodeRow({ episode, latest = false }: EpisodeRowProps) {
  return (
    <Link
      to={`/detail/${episode.id}`}
      className="group flex gap-3 p-2 rounded-lg hover:bg-background-100/80 transition-colors cursor-pointer"
    >
      <div className="relative w-[72px] h-[104px] shrink-0 rounded-md overflow-hidden bg-background-900">
        <img
          src={episode.cover}
          alt={episode.title}
          title={`${episode.title} 剧情介绍`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="min-w-0 flex-1 py-1">
        <div className="flex items-center gap-2">
          <span className="text-[10px] font-label tracking-wider text-accent-500">
            EP {String(episode.number).padStart(2, "0")}
          </span>
          {latest && (
            <span className="px-1.5 h-4 rounded bg-primary-500 text-background-50 text-[10px] flex items-center">
              NEW
            </span>
          )}
        </div>
        <h4 className="mt-1 text-sm font-medium text-foreground-950 leading-5 line-clamp-1">
          {episode.title}
        </h4>
        <p className="mt-1 text-xs leading-5 text-foreground-500 line-clamp-2">
          {episode.synopsis}
        </p>
        <p className="mt-1 text-[11px] text-foreground-600">{episode.releaseDate}</p>
      </div>
    </Link>
  );
}